import { Auth } from "@aws-amplify/auth";
import { useLocalStorageState } from "ahooks";
import { isEmpty } from "lodash";

import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";

import { getUserInfoAction } from "@/api/alert";
import { USERINFO_EXPIRES_MAX_AGE } from "@/constants/config";
import { MEMBERSHIP_CONFIG } from "@/constants/membership";
import { GlobalStoreParams, globalStoreInitData } from "@/context/globalStoreContext";
import useEvent from "@/hooks/useEvent";

const useGlobalStore = () => {
  const [store, setStore] = useState<GlobalStoreParams>({ ...globalStoreInitData });
  const { pathname } = useLocation();

  const [persistStore, setPersistStore] = useLocalStorageState("__globalStore__");

  const getUserInfo = useEvent(async () => {
    try {
      // retrieve the previous user information in the local storage for temporary use
      // const localContext = localStorage.getItem("globalContext");
      // if (localContext) {
      //   const parseData = JSON.parse(localContext);
      //   // 未过期，使用本地数据
      //   if (parseData.local_expire_date > Date.now()) {
      //     setStore({ ...parseData, load: true });
      //     return;
      //   }
      // }

      // retrieve the user information from the backend and update the update the value
      const res = await getUserInfoAction();
      if (res === null) {
        return;
      }

      let user_logged_in;
      try {
        const currentUser = await Auth.currentAuthenticatedUser();
        user_logged_in = true;
      } catch (error) {
        user_logged_in = false;
      }
      // Check if href contains any of strings in a list
      // const list_str = ["pro.awardtool.com", "localhost"];
      // const list_str = ["pro.awardtool.com"];
      // const tartget_url = list_str.some((str) => window.location.href.includes(str));
      // Determine how to show the upsell
      // res.user_type = res.user_type;
      const route_range = MEMBERSHIP_CONFIG["routes_range"][res.user_type || 0];
      const flight_range = MEMBERSHIP_CONFIG["flight_range"][res.user_type || 0];
      const show_upsell = Number(res.user_type) === 0;
      const route_calendar_range = MEMBERSHIP_CONFIG["route_calendar_range"][res.user_type || 0];
      const logged_in = true;
      const expire_date = res?.expire_date;
      const referral_code = res?.referral_code;
      const referral_status = res?.referral;
      const influencer = res?.influencer;
      const promotion = res?.promotion;
      // update the user information with the backend data, and store a copy in the local storage
      const final_store = {
        ...res,
        route_range,
        flight_range,
        route_calendar_range,
        show_upsell,
        logged_in,
        expire_date,
        referral_code,
        referral_status,
        influencer,
        promotion,
        user_logged_in,
        user_preference:
          res?.user_preference && !isEmpty(res?.user_preference)
            ? res?.user_preference
            : globalStoreInitData.user_preference,
      };
      setStore({
        ...final_store,
        load: true,
      });

      setPersistStore({ ...final_store });
      // Store in the local storage for next use
      localStorage.setItem(
        "globalContext",
        JSON.stringify({ ...final_store, local_expire_date: Date.now() + USERINFO_EXPIRES_MAX_AGE })
      );
    } catch (error) {
      console.log(error);
    }
  });

  const getUserInfoForHome = async () => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
    } catch (error) {
      getUserInfo();
    }
  };

  useEffect(() => {
    if (pathname !== "/") {
      getUserInfo();
    } else {
      getUserInfoForHome();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return useMemo(
    () => ({
      store: {
        ...store,
        persistStore,
      },
      getUserInfo,
    }),
    [store, persistStore, getUserInfo]
  );
};

export default useGlobalStore;
